import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/authContext';


function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Checking session…
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}


function PublicRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
  
    if (isLoading) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          Checking session…
        </div>
      );
    }
    if (isAuthenticated) {
      return <Navigate to="/" replace />;
    }
  
    return children;
}
  


export {ProtectedRoute, PublicRoute};